import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface SEOConfig {
  id: string;
  page_route: string;
  page_name: string;
  title?: string;
  description?: string;
  keywords?: string;
  author?: string;
  canonical_url?: string;
  og_title?: string;
  og_description?: string;
  og_image?: string;
  og_image_alt?: string;
  og_type?: string;
  og_url?: string;
  og_site_name?: string;
  image_url?: string;
  copyright?: string;
  is_active: boolean;
}

export const useSEO = () => {
  const [seoConfig, setSeoConfig] = useState<SEOConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const loadSEOConfig = async () => {
      try {
        setLoading(true);
        
        // First try to get SEO config for the current route
        let { data: routeConfig } = await supabase
          .from('seo_config')
          .select('*')
          .eq('page_route', location.pathname)
          .eq('is_active', true)
          .maybeSingle();

        // If no specific route config, try to get home page config as fallback
        if (!routeConfig && location.pathname !== '/') {
          const { data: homeConfig } = await supabase
            .from('seo_config')
            .select('*')
            .eq('page_route', '/')
            .eq('is_active', true)
            .maybeSingle();
          
          routeConfig = homeConfig;
        }

        setSeoConfig(routeConfig);
      } catch (error) {
        console.error('Error loading SEO config:', error);
        setSeoConfig(null);
      } finally {
        setLoading(false);
      }
    };

    loadSEOConfig();
  }, [location.pathname]);

  return { seoConfig, loading };
};